// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { Radio } from '@mui/material';

export const StyledUiRadio = styled(Radio)(
  () => css`
    .MuiSvgIcon-root {
      font-size: 1.669rem;
      fill: #a6a9af;
    }
    &.Mui-checked {
      .MuiSvgIcon-root {
        font-size: 1.669rem;
        fill: #199da3;
      }
    }
    &.Mui-disabled {
      opacity: 0.4;
    }
  `
);
